<script>
import { mapActions } from 'vuex';
import store from '../../store';

export default {
  name: 'BookingWrapper',
  methods: {
    ...mapActions({
      resetState: 'booking/resetState',
    }),
  },
  destroyed() {
    this.resetState();
  },
  beforeRouteEnter(to, from, next) {
    if (to.params.bookingId) {
      store.dispatch('booking/bookingWithCustomerAndStaysByBookingIdLoad', to.params.bookingId)
        .finally(() => {
          next();
        });
    }
  },
};
</script>

<template>
  <router-view />
</template>



// WEBPACK FOOTER //
// src/pages/booking/BookingWrapper.vue